const MODALITY_LABEL: Record<string, string> = {
  robo_pintor: 'Robô Pintor',
  seguidor_de_linha: 'Seguidor de Linha',
};

const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI'];

/** "seguidor_de_linha" → "Seguidor de Linha". Sem slug: "Modalidade". */
export const modalityLabel = (slug?: string | null): string =>
  (slug && MODALITY_LABEL[slug]) || slug || 'Modalidade';

/**
 * "category_2" → "Categoria II". A API manda o enum da equipe; a tela nunca
 * mostra o valor cru. Formato desconhecido volta como veio.
 */
export const categoryLabel = (category?: string | null): string => {
  if (!category) return '—';
  const match = /^category_(\d+)$/.exec(category);
  if (!match) return category;
  const number = Number(match[1]);
  return `Categoria ${ROMAN[number - 1] ?? number}`;
};
